<template>
  <div class="notifications-container position-fixed end-0 top-0 p-3" style="z-index: 1100; width: 350px;">
    <!-- Информационные уведомления -->
    <transition-group name="notification">
      <div
          v-for="(item, index) in notificationsStore.informs"
          :key="`inform-${index}-${item.message}`"
          class="notification mb-3 alert alert-info d-flex align-items-center"
          role="alert"
      >
        <div class="me-2 flex-grow-1">
          <i class="bi bi-info-circle-fill me-2"></i>
          {{ item.message }}
        </div>
        <button
            type="button"
            class="btn-close"
            @click="removeNotification(index, 'inform')"
            aria-label="Close"
        ></button>
      </div>
    </transition-group>

    <!-- Уведомления об ошибках -->
    <transition-group name="notification">
      <div
          v-for="(item, index) in notificationsStore.errors"
          :key="`error-${index}-${item.message}`"
          class="notification mb-3 alert alert-danger d-flex align-items-center"
          role="alert"
      >
        <div class="me-2 flex-grow-1">
          <i class="bi bi-exclamation-triangle-fill me-2"></i>
          {{ item.message }}
        </div>
        <button
            type="button"
            class="btn-close"
            @click="removeNotification(index, 'error')"
            aria-label="Close"
        ></button>
      </div>
    </transition-group>
  </div>
</template>

<style scoped>
.notification {
  transition: all 0.3s ease;
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075);
}

.notification-enter-from {
  opacity: 0;
  transform: translateX(100px);
}

.notification-leave-to {
  opacity: 0;
  transform: scale(0.8);
}

.notification-leave-active {
  position: absolute;
  width: 100%;
}

.notification-move {
  transition: transform 0.3s ease;
}

/* Иконки Bootstrap Icons */
.bi {
  font-size: 1.25rem;
}
.bi-info-circle-fill {
  color: #0dcaf0;
}
.bi-exclamation-triangle-fill {
  color: #dc3545;
}
</style>

<script setup>
import { watch } from 'vue'
import {useNotificationsStore} from "@/store/notifications";

const notificationsStore = useNotificationsStore()
notificationsStore.onInfo()
notificationsStore.onError()

// Функция для удаления уведомления по индексу
const removeNotification = (index, type) => {
  if (type === 'inform') {
    notificationsStore.informs.splice(index, 1)
  } else {
    notificationsStore.errors.splice(index, 1)
  }
}

// Устанавливаем таймеры для автоматического удаления
const setupAutoRemove = (type) => {
  const array = type === 'inform' ? notificationsStore.informs : notificationsStore.errors
  const timeout = type === 'inform' ? 5000 : 8000

  array.forEach((_, index) => {
    setTimeout(() => {
      removeNotification(index, type)
    }, timeout)
  })
}

// Отслеживаем изменения массивов
watch(() => notificationsStore.informs.length, () => setupAutoRemove('inform'))
watch(() => notificationsStore.errors.length, () => setupAutoRemove('error'))
</script>
